export enum WithoutAssessment {
  NoAssessmentAdded = 'noAssessmentAdded',
}

export const getWithoutAssessmentLabel = (value: string): string => {
  const labels: Record<string, string> = {
      [WithoutAssessment.NoAssessmentAdded]: 'No Assessment Added',
  };
  return labels[value] || value;
};
